const DEFAULT_IFRAME_WIDTH = '640';
const DEFAULT_IFRAME_HEIGHT = '480';

/** Returns the first <iframe>...</iframe> from a pasted embed snippet with style stripped and width/height forced to 640x480 defaults; returns input unchanged when no iframe is present. */
export function extractIframeFromEmbed(input: string): string {
  if (typeof DOMParser === 'undefined') {
    return input;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');

  const iframe = doc.querySelector('iframe');

  if (!iframe) {
    return input;
  }

  iframe.removeAttribute('style');
  iframe.removeAttribute('width');
  iframe.removeAttribute('height');

  iframe.setAttribute('width', DEFAULT_IFRAME_WIDTH);
  iframe.setAttribute('height', DEFAULT_IFRAME_HEIGHT);

  return iframe.outerHTML;
}
